import { z, ZodType } from 'zod';

export interface SportInjury {
  f01_forbund: string;
  f02_klubb: string;
  f03_fylke: string;
  f04_idrettsforsikring: string;
  f05_skadelidte: string;
  f06_skadelidteFodselsdato: string;
  f07_foresatt: string;
  f08_foresattFodselsdato: string;
  f09_adresse: string;
  f10_postnummer: string;
  f11_poststed: string;
  f12_telefonnummer: string;
  f13_epostadresse: string;
  f14_kontonummer: string;
  f15_skadedato: string;
  f16_skadeKontekst: string;
  f17_skadeKontekstAnnet: string;
  f18_skadeHvordan: string;
  f19_skadeAkutt?: string;
  f20_skadeKroppsdel: string;
  f21_skadeDetaljertBeskrivelse: string;
  f22_skadeUnderlag: string;
  f23_beskyttelsesutstyr: string;
  f24_skadeHvor: string;
  f25_annet: string;
  f26_samtykke: boolean;
}

export const sportInjuryForm: ZodType<SportInjury> = z.object({
  f01_forbund: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f02_klubb: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f03_fylke: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f04_idrettsforsikring: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f05_skadelidte: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f06_skadelidteFodselsdato: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f07_foresatt: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f08_foresattFodselsdato: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f09_adresse: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f10_postnummer: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f11_poststed: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f12_telefonnummer: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f13_epostadresse: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f14_kontonummer: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f15_skadedato: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f16_skadeKontekst: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f17_skadeKontekstAnnet: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f18_skadeHvordan: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f19_skadeAkutt: z
    .string({
      required_error: 'Obligatorisk felt',
    })
    .optional(),
  f20_skadeKroppsdel: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f21_skadeDetaljertBeskrivelse: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f22_skadeUnderlag: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f23_beskyttelsesutstyr: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f24_skadeHvor: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f25_annet: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f26_samtykke: z.boolean({
    required_error: 'Obligatorisk felt',
  }),
});

export interface EquinorAccident {
  f01_name: string;
  f02_dateOfBirth: string;
  f03_address: string;
  f04_postalCode: string;
  f05_city: string;
  f06_position: string;
  f07_dateEmployment: string;
  f08_email: string;
  f09_phoneNumber: string;
  f10_bankAccount: string;
  f11_dateOfInjury: string;
  f12_relation: string;
  f13_object: string;
  f14_spouse: string;
  f15_relation: string;
}

export const equinorAccidentForm: ZodType<EquinorAccident> = z.object({
  f01_name: z.string({
    required_error: 'Required field',
  }),
  f02_dateOfBirth: z.string({
    required_error: 'Required field',
  }),
  f03_address: z.string({
    required_error: 'Required field',
  }),
  f04_postalCode: z.string({
    required_error: 'Required field',
  }),
  f05_city: z.string({
    required_error: 'Required field',
  }),
  f06_position: z.string({
    required_error: 'Required field',
  }),
  f07_dateEmployment: z.string({
    required_error: 'Required field',
  }),
  f08_email: z.string({
    required_error: 'Required field',
  }),
  f09_phoneNumber: z.string({
    required_error: 'Required field',
  }),
  f10_bankAccount: z.string({
    required_error: 'Required field',
  }),
  f11_dateOfInjury: z.string({
    required_error: 'Required field',
  }),
  f12_relation: z.string({
    required_error: 'Required field',
  }),
  f13_object: z.string({
    required_error: 'Required field',
  }),
  f14_spouse: z.string({
    required_error: 'Required field',
  }),
  f15_relation: z.string({
    required_error: 'Required field',
  }),
});

export interface EquinorDeath {
  f01_deceased: string;
  f02_name: string;
  f03_dateOfBirth: string;
  f04_address: string;
  f05_postalCode: string;
  f06_city: string;
  f07_position: string;
  f08_dateDeath: string;
  f09_dateEmployment: string;
  f10_occurDuringWorkingHours: string;
  f11_relationToEquinor: string;
  f12_maritalStatus: string;
  f13_childrenUnder21: string;
  f14_contactName: string;
  f15_contactDateBirth: string;
  f16_contactAddress: string;
  f17_contactPostalCode: string;
  f18_contactCity: string;
  f19_contactEmail: string;
  f20_contactPhone: string;
  f21_contactRelation: string;
}

export const equinorDeathForm: ZodType<EquinorDeath> = z.object({
  f01_deceased: z.string({
    required_error: 'Required field',
  }),
  f02_name: z.string({
    required_error: 'Required field',
  }),
  f03_dateOfBirth: z.string({
    required_error: 'Required field',
  }),
  f04_address: z.string({
    required_error: 'Required field',
  }),
  f05_postalCode: z.string({
    required_error: 'Required field',
  }),
  f06_city: z.string({
    required_error: 'Required field',
  }),
  f07_position: z.string({
    required_error: 'Required field',
  }),
  f08_dateDeath: z.string({
    required_error: 'Required field',
  }),
  f09_dateEmployment: z.string({
    required_error: 'Required field',
  }),
  f10_occurDuringWorkingHours: z.string({
    required_error: 'Required field',
  }),
  f11_relationToEquinor: z.string({
    required_error: 'Required field',
  }),
  f12_maritalStatus: z.string({
    required_error: 'Required field',
  }),
  f13_childrenUnder21: z.string({
    required_error: 'Required field',
  }),
  f14_contactName: z.string({
    required_error: 'Required field',
  }),
  f15_contactDateBirth: z.string({
    required_error: 'Required field',
  }),
  f16_contactAddress: z.string({
    required_error: 'Required field',
  }),
  f17_contactPostalCode: z.string({
    required_error: 'Required field',
  }),
  f18_contactCity: z.string({
    required_error: 'Required field',
  }),
  f19_contactEmail: z.string({
    required_error: 'Required field',
  }),
  f20_contactPhone: z.string({
    required_error: 'Required field',
  }),
  f21_contactRelation: z.string({
    required_error: 'Required field',
  }),
});

export interface CarPaperClaimForm {
  f01_antall: string;
  f02_sprak: string;
  f03_fornavn: string;
  f04_etternavn: string;
  f05_addresse: string;
  f06_postnummer: string;
  f07_poststed: string;
}

export const carPaperForm: ZodType<CarPaperClaimForm> = z.object({
  f01_antall: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f02_sprak: z.string(),
  f03_fornavn: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f04_etternavn: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f05_addresse: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f06_postnummer: z.string({
    required_error: 'Obligatorisk felt',
  }),
  f07_poststed: z.string({
    required_error: 'Obligatorisk felt',
  }),
});

export type CustomerDetail = {
  fullName: string;
  dateOfBirth: string;
  policyNumber: string;
  emailAddress: string;
  phoneNumber: string;
  postAddress: string;
  postalCode: string;
  city: string;
  country: string;
  bankAccountNumber: string;
  swift?: string;
  bankAccountCountry: string;
};

export type CancellationValues = {
  departureCountry: string;
  arrivalCountry: string;
  reason: string;
  cancellationOccurence: string;
};

export type MedicalValues = {
  reportedToGjTravelAssistance: string;
  claimNumberGjTravelAssistance?: string;
  changeReturnTimeDate: string;
};

export type DelayedLuggageValues = {
  luggageDelayOccur: string;
  countryLuggageDelayOccur: string;
};

export type DelayedOrCancelledTransportationValues = {
  delayDuration: string;
  customerInformed: string;
  departureCountry: string;
  arrivalCountry: string;
};

export type DamagedOrLostBelongingsValues = {
  incidentCountryIsResidenceCountry: string;
  incidentReportedElsewhere: string;
  incidentReportedElsewhereLocation?: string;
};

export type EquinorTravelValues = {
  customerDetail: CustomerDetail;
  injuredParty: string;
  otherImpactedParts?: string;
  affectedFullName?: string;
  affectedDateOfBirth?: string;
  incidentDate?: string;
  incidentCause?: string;
  country?: string;
  travelPurpose: string;
  tripStartBookedDate: string;
  tripEndCancelledDate: string;
  compensation: string;
  detailedDescriptionCompensation?: string;
  detailedIncidentDescription?: string;
  damagedOrLostBelongings?: DamagedOrLostBelongingsValues;
  delayedOrCancelledTransportation?: DelayedOrCancelledTransportationValues;
  delayedLuggage?: DelayedLuggageValues;
  cancellation?: CancellationValues;
  medical?: MedicalValues;
};

export type CountRequest = {
  type: FormType;
};

export enum FormType {
  CANCELLATION = 'CANCELLATION',
  MEDICAL = 'MEDICAL',
  DAMAGED_LOST_BELONGINGS = 'DAMAGED_LOST_BELONGINGS',
  DELAYED_LUGGAGE = 'DELAYED_LUGGAGE',
  DELAYED_OR_CANCELLED_TRANSPORTATION = 'DELAYED_OR_CANCELLED_TRANSPORTATION',
  OTHER = 'OTHER',
}

export const equinorTravelForm: ZodType<EquinorTravelValues> = z.object({
  customerDetail: z.object({
    fullName: z.string({ required_error: 'Full name is required' }),
    dateOfBirth: z.string({ required_error: 'Date of birth is required' }),
    policyNumber: z.string({ required_error: 'Policy number is required' }),
    emailAddress: z
      .string({ required_error: 'Email address is required' })
      .email('Invalid email format'),
    phoneNumber: z.string({ required_error: 'Phone number is required' }),
    postAddress: z.string({ required_error: 'Post address is required' }),
    postalCode: z.string({ required_error: 'Postal code is required' }),
    city: z.string({ required_error: 'City is required' }),
    country: z.string({ required_error: 'Country is required' }),
    bankAccountNumber: z.string({
      required_error: 'Bank account number is required',
    }),
    swift: z.string().optional(),
    bankAccountCountry: z.string({
      required_error: 'Bank account country is required',
    }),
  }),
  injuredParty: z.string({ required_error: 'Injured party is required' }),
  otherImpactedParts: z.string().optional(),
  affectedFullName: z.string().optional(),
  affectedDateOfBirth: z.string().optional(),
  incidentDate: z.string({ required_error: 'Incident date is required' }).optional(),
  incidentCause: z.string().optional(),
  country: z.string({ required_error: 'Country is required' }).optional(),
  travelPurpose: z.string({ required_error: 'Travel purpose is required' }),
  tripStartBookedDate: z.string({ required_error: 'Date is required' }),
  tripEndCancelledDate: z.string({ required_error: 'Date is required' }),
  compensation: z.string({ required_error: 'Compensation is required' }),
  detailedDescriptionCompensation: z
    .string({
      required_error: 'Field is required',
    })
    .optional(),
  detailedIncidentDescription: z
    .string({
      required_error: 'Field is required',
    })
    .optional(),
  damagedOrLostBelongings: z
    .object({
      incidentCountryIsResidenceCountry: z.string(),
      incidentReportedElsewhere: z.string(),
      incidentReportedElsewhereLocation: z.string().optional(),
    })
    .optional(),
  delayedOrCancelledTransportation: z
    .object({
      delayDuration: z.string(),
      customerInformed: z.string(),
      departureCountry: z.string(),
      arrivalCountry: z.string(),
    })
    .optional(),
  delayedLuggage: z
    .object({
      luggageDelayOccur: z.string(),
      countryLuggageDelayOccur: z.string(),
    })
    .optional(),
  cancellation: z
    .object({
      departureCountry: z.string(),
      arrivalCountry: z.string(),
      reason: z.string(),
      cancellationOccurence: z.string(),
    })
    .optional(),
  medical: z
    .object({
      reportedToGjTravelAssistance: z.string(),
      claimNumberGjTravelAssistance: z.string().optional(),
      changeReturnTimeDate: z.string(),
    })
    .optional(),
});
